import { EventEmitter, Injectable, Output } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { catchError, map } from 'rxjs/operators';

import { environment } from 'src/environments/environment';

const httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};

@Injectable()
export class ChatApiService {
    @Output() tokenExpired: EventEmitter<any> = new EventEmitter();

    private readonly poesslApiUrl = environment.poesslApiUrl;
    public readonly apiUrl = environment.apiUrl;
    private readonly apiKey = environment.apiKey;

    public readonly apiUrlLive = environment.apiUrlLive;
    public readonly apiUrlTest = environment.apiUrlTest;

    public nexClass: boolean = false;
    public showStep: number = null;
    public viewMode: string = '';

    public editing: any = {
        msgId: 0,
        msgToEdit: null,
        msgToEditCopy: null,
        answer: 0,

        groupId: null,
        groupTitle: '',
    }

    constructor(private http: HttpClient) {

    }

    public resetControls() {
        this.editing.msgId = 0;
        this.editing.msgToEdit = null;
        this.editing.groupId = null;
    }

    public getTestUser(id): Observable<any[]> {
        return this.http.get<any[]>(
            `${this.apiUrl}/public/testuser/view/${id}`
        );
    }

    public getChatForSupervisor(supervisor): Observable<any[]> {
        return this.http.get<any[]>(
            `${this.apiUrl}/private/chat/supervisor/${supervisor}`
        );
    }
    public getChatForCustomer(email, orderHash, itemId: number = 0): Observable<any[]> {
        const headers = new HttpHeaders({
            // Authorization: 'Bearer public'
        });
        return this.http
            .post<any>(
                `${this.apiUrl}/public/chat/customer`,
                // `https://api.dieshop.app:8082/public/chat/customer`,
                { email, orderHash, itemId },
                { headers }
            )
            .pipe(
                map((res: any) => {
                    return res;
                })
            );
    }

    public addBoard(user, name): Observable<any[]> {
        const headers = new HttpHeaders({
            // Authorization: 'Bearer public'
        });
        return this.http
            .post<any>(
                `${this.apiUrl}/board/add`,
                { user, name },
                { headers }
            )
            .pipe(
                map((res: any) => {
                    return res;
                })
            );
    }

    public saveBoardColumn(column): Observable<any[]> {
        const headers = new HttpHeaders({
            // Authorization: 'Bearer public'
        });
        return this.http
            .post<any>(
                `${this.apiUrl}/board/column/save`,
                { column },
                { headers }
            )
            .pipe(
                map((res: any) => {
                    return res;
                })
            );
    }
    public deleteBoardColumn(column): Observable<any[]> {
        const headers = new HttpHeaders({
            // Authorization: 'Bearer public'
        });
        return this.http
            .post<any>(
                `${this.apiUrl}/board/column/delete`,
                { column },
                { headers }
            )
            .pipe(
                map((res: any) => {
                    return res;
                })
            );
    }
    public resortBoardColumn(idSorts, boardId): Observable<any[]> {
        const headers = new HttpHeaders({
            // Authorization: 'Bearer public'
        });
        return this.http
            .post<any>(
                `${this.apiUrl}/board/column/resort`,
                { idSorts, boardId },
                { headers }
            )
            .pipe(
                map((res: any) => {
                    return res;
                })
            );
    }

    public resortBoardCards(idSorts, colSource, colTarget): Observable<any[]> {
        const headers = new HttpHeaders({
            // Authorization: 'Bearer public'
        });
        return this.http
            .post<any>(
                `${this.apiUrl}/board/card/resort`,
                { idSorts, colSource, colTarget },
                { headers }
            )
            .pipe(
                map((res: any) => {
                    return res;
                })
            );
    }

    public saveBoardCard(card, column): Observable<any[]> {
        const headers = new HttpHeaders({
            // Authorization: 'Bearer public'
        });
        return this.http
            .post<any>(
                `${this.apiUrl}/board/card/save`,
                { card, column },
                { headers }
            )
            .pipe(
                map((res: any) => {
                    return res;
                })
            );
    }

    public saveBoard(board): Observable<any[]> {
        const headers = new HttpHeaders({
            // Authorization: 'Bearer public'
        });
        return this.http
            .post<any>(
                `${this.apiUrl}/board/save`,
                { board },
                { headers }
            )
            .pipe(
                map((res: any) => {
                    return res;
                })
            );
    }

    public sendChatMessage(chat, message, getResponse: boolean = true) {

        const headers = new HttpHeaders({
            // Authorization: 'Bearer public'
        });
        return this.http
            .post<any>(
                `${this.apiUrl}/private/chat/send-message`,
                { chat, message, getResponse },
                { headers }
            )
            .pipe(
                map((res: any) => {

                    if (this.showStep > 0) { this.nextStep(true); }
                    return res;
                })
            );
    }

    public updateChatReadAt(email, from, id): Observable<any[]> {
        const headers = new HttpHeaders({
            // Authorization: 'Bearer public'
        });
        return this.http
            .post<any>(
                `${this.apiUrl}/public/chat/update-read`,
                { email, from, id },
                { headers }
            )
            .pipe(
                map((res: any) => {
                    return res;
                })
            );
    }
    public updateChatDeletedAt(email, from, id): Observable<any[]> {
        const headers = new HttpHeaders({
            // Authorization: 'Bearer public'
        });
        return this.http
            .post<any>(
                `${this.apiUrl}/public/chat/update-deleted`,
                { email, from, id },
                { headers }
            )
            .pipe(
                map((res: any) => {
                    return res;
                })
            );
    }
    public resortChat(email, from, id, dir): Observable<any[]> {
        const headers = new HttpHeaders({
            // Authorization: 'Bearer public'
        });
        return this.http
            .post<any>(
                `${this.apiUrl}/public/chat/update-sorting`,
                { email, from, id, dir },
                { headers }
            )
            .pipe(
                map((res: any) => {
                    return res;
                })
            );
    }

    public getContactData(): Observable<any[]> {
        return this.http.get<any[]>(
            `${this.apiUrl}/private/addresses/`
        );
    }

    public sendMessage(message) {
        const headers = new HttpHeaders({
            // Authorization: 'Bearer public'
        });
        return this.http
            .post<any>(
                `${this.apiUrl}/private/message/send`,
                {
                    message
                },
                { headers }
            )
            .pipe(
                map((res: any) => {
                    return res;
                })
            );
    }

    public updateOrderStatus(orderId, status) {
        const headers = new HttpHeaders({
            // Authorization: 'Bearer public'
        });
        return this.http
            .post<any>(
                `${this.apiUrl}/private/order/status`,
                { orderId, status },
                { headers }
            )
            .pipe(
                map((res: any) => {
                    return res;
                })
            );
    }

    public exportBueroPlus(order) {
        const headers = new HttpHeaders({
            // Authorization: 'Bearer public'
        });
        return this.http
            .get<any>(
                `${this.apiUrl}/private/order/export/${order.orderHash}`,
                { headers }
            )
            .pipe(
                map((res: any) => {
                    return res;
                })
            );
    }

    public getChatGroups() {
        const headers = new HttpHeaders({
            // Authorization: 'Bearer public'
        });
        return this.http
            .get<any>(
                `${this.apiUrl}/private/chat/groups`,
                { headers }
            )
            .pipe(
                map((res: any) => {
                    return res;
                })
            );
    }

    public getChatByItemId(i) {
        const headers = new HttpHeaders({
            // Authorization: 'Bearer public'
        });
        return this.http
            .get<any>(
                `${this.apiUrl}/private/chat/item-id/${i.item.id}`,
                { headers }
            )
            .pipe(
                map((res: any) => {
                    return res;
                })
            );
    }

    nextStep(next: boolean = true) {
      if (next) {
        this.showStep++;
        this.nexClass = true;
      } else {
        if (this.showStep > 1) {
          this.showStep--;
          this.nexClass = false;
        }
      }
      console.log(8471, this.showStep);
      window.parent.postMessage({ step: this.showStep }, '*');
    }

    public wrapURL(text, shortCodes: any = {}) { 
        if(text) {

            // Create your regex pattern for urls 
            let urlPattern = /\b((?:[a-z][\w-]+:(?:\/{1,3}|[a-z0-9%])|www\d{0,3}[.]|[a-z0-9.\-]+[.][a-z]{2,4}\/)(?:[^\s()<>]+|\(([^\s()<>]+|(\([^\s()<>]+\)))*\))+(?:\(([^\s()<>]+|(\([^\s()<>]+\)))*\)|[^\z`!()\[\]{};:'".,<>?«»“”‘’]))/ig; 
            // Check string for any url patterns and wrap them in anchor tags 
            let result = text.replace(urlPattern, function(url) { 
                return `<a href="${url.trim()}" target="_blank">${url.trim()}</a>`; 
            }); 

            if (shortCodes) {
                for (const key of Object.keys(shortCodes)) {
                    result = result.replace(`{${key}}`,shortCodes[key]);
                }
            }

            return result; 
        }
    } 
    public nl2br(str) {
        if(str) {
            const arr = str.split(`____________`);
            str = arr[0].trim();
            str = (str + '').replace(/\n{3,}\s*/g, '\n\n');
            str = str.replace(/\n{3,}\s*/g, '\n');
            // str = (str + '').replace(/\n+/g, "\n\n");
            str = str.replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1' + '<br />' + '$2').trim();
            return str;
        }
    }

    public addChatContainer(container) {
        const headers = new HttpHeaders({
            // Authorization: 'Bearer public'
        });
        return this.http
            .post<any>(
                `${this.apiUrl}/backend-chat/container`,
                {
                    container
                },
                { headers }
            )
            .pipe(
                map((res: any) => {
                    return res;
                })
            );
    }

    public addChatItemToGroup(item, containerId) {
        const headers = new HttpHeaders({
            // Authorization: 'Bearer public'
        });
        return this.http
            .post<any>(
                `${this.apiUrl}/backend-chat/container/item`,
                {
                    item, containerId
                },
                { headers }
            )
            .pipe(
                map((res: any) => {
                    return res;
                })
            );
    }

    public getBoards() {
        return this.http.get<any[]>(
            `${this.apiUrl}/board/list`
        );
    }
    public getBoardColumns(boardId: number) {
        return this.http.get<any[]>(
            `${this.apiUrl}/board/column/list/${boardId}`
        );
    }
    public getBoardsAndColumnsSelect(company: string = 'logged-in-user') {
        return this.http.get<any[]>(
            `${this.apiUrl}/board/board-and-column/list/${company}`
        );
    }
    public saveOrderWithItems(data) {
        const headers = new HttpHeaders({
            // Authorization: 'Bearer public'
        });
        return this.http
            .post<any>(
                `${this.apiUrl}/backend-chat/order/save`,
                data,
                { headers }
            )
            .pipe(
                map((res: any) => {
                    return res;
                })
            );
    }
    public createOrderWithItems(data) {
        const headers = new HttpHeaders({
            // Authorization: 'Bearer public'
        });
        return this.http
            .post<any>(
                `${this.apiUrl}/backend-chat/order/create`,
                data,
                { headers }
            )
            .pipe(
                map((res: any) => {
                    return res;
                })
            );
    }
    public payOrderItems(data, paymentOption, paymentData: any = null) {
        const headers = new HttpHeaders({
            // Authorization: 'Bearer public'
        });
        return this.http
            .post<any>(
                `${this.apiUrl}/public/place/order-items/pay`,
                {
                    data,
                    paymentOption,
                    paymentData
                },
                { headers }
            )
            .pipe(
                map((res: any) => {
                    return res;
                })
            );
    }

    public sendUrlPostCall(url, postBody) {
        const headers = new HttpHeaders({
            // Authorization: 'Bearer public'
        });
        return this.http
            .post<any>(
                `${url}`,
                postBody,
                { headers }
            )
            .pipe(
                map((res: any) => {
                    return res;
                })
            );
    }
}
